import styled from 'styled-components';

import { TEXT } from 'constants/colors';

export default styled.div`
  .additional-cell {
    position: relative;

    .text {
      font-style: italic;
      font-family: 'signikasemibold';
    }

    button {
      margin-left: 4px;
    }

    .text + button {
      margin-left: 15px;
    }

    .clone-btn {
      svg {
        font-size: 15px;
      }
    }

    .actions {
      position: absolute;
      top: 0;
    }
  }

  .show-history {
    margin-top: 20px;
  }

  table {
    width: auto;

    td {
      vertical-align: bottom;
    }

    th,
    td {
      width: 60px;

      &:first-child {
        width: 300px;
      }
    }
  }

  .fs17 {
    font-size: 17px;
  }

  .pr26 {
    padding-right: 26px;
  }

  .info-hours {
    position: absolute;
    top: 50%;
    transform: translate(10px, -50%);
  }

  .source-row {
    th {
      padding-top: 20px;
      padding-bottom: 30px;
    }
  }

  .hours-cell,
  .percentage-cell {
    .MuiInput-root {
      input {
        text-align: center;
      }

      &.Mui-disabled {
        color: ${TEXT} !important;

        &::before {
          display: none;
        }

        input {
          -webkit-text-fill-color: unset !important;
        }
      }
    }
  }

  .actions-cell {
    position: relative;
    padding: 0;
    width: 0;

    .actions {
      position: absolute;
      left: 10px;
      top: 0;
      height: 100%;
    }
  }

  .distribution-entry {
    .details {
      max-width: 400px;
      margin-left: 70px;
    }
  }
`;
